import { Button } from '@/components/ui/button'

interface ConfirmButtonProps {
  onConfirm: () => void
}

export function ConfirmButton({ onConfirm }: ConfirmButtonProps) {
  return (
    <div className="flex justify-center p-3">
      <Button
        type="button"
        onClick={onConfirm}
        className="bg-black hover:bg-gray-800 text-white px-6"
      >
        OK
      </Button>
    </div>
  )
}
